import { ModelView } from "../model.view";
import {
  ClassificationModelVersion,
  ClassificationStoreModel,
  DefaultClassificationStoreModel,
} from "@bitwarden/web-vault/app/models/store/classification.store.model";

export class ClassificationView extends ModelView<ClassificationStoreModel> {
  protected version: ClassificationModelVersion;

  name: string;
  generatedDefault: boolean = false; // when we import data and create accounts if there are no classification-renderer related to transaction
  weight: number;

  constructor(model?: ClassificationStoreModel) {
    super(model);

    if (typeof model === "object") {
      this.name = model.n;
      this.generatedDefault = model.gd;
    } else {
      this.version = DefaultClassificationStoreModel.v;
    }
  }

  toStoreModel(): ClassificationStoreModel {
    return {
      dc: this.dateCreated.toDateString(),
      dm: this.dateModified.toDateString(),
      id: this.id,
      vid: this.vaultId,
      v: this.version,
      n: this.name,
      gd: this.generatedDefault,
    };
  }

  clone(): ClassificationView {
    return new ClassificationView(this.toStoreModel());
  }
}
